
import { ButtonFieldConfig, DynamicFormArray, FormFieldConfig, Props } from './form.model';
import { defaultSearchContainerButtons, FirstNameText, LastNameText, SpinIdNumber, FieldNames, DefaultText, BrandDropdown } from './form-fields.model';
import { DataTableSchema, DefaultTableSchema } from './dynamic-data-table.model';
import { FETCH_METHODS, SearchConfig } from './api.model';

const FormFieldArray: FormFieldConfig[] = structuredClone([SpinIdNumber,
    FirstNameText,LastNameText,
    {...structuredClone(BrandDropdown), showSelect:false,multiple:true,defaultValue:['LEXUS','TOYOTA']},
    {...structuredClone(DefaultText), fieldName: FieldNames.Dealer, displayName: 'Dealer Code/ Name', pattern: String.raw`^[a-zA-Z0-9\s/-]+$`}]);

const FormButtonArray: ButtonFieldConfig[] = structuredClone(defaultSearchContainerButtons);

export const JobHistorySearchConfig:SearchConfig = {
    method:"POST",
    path:"jobHistory",
    body:{
        "spinId":"",
        "firstName":"",
        "lastName":"",
        "dealerNumber":"",
    }
}
export const PCSupportExportSearchConfig:SearchConfig = {
    method:FETCH_METHODS['Post'],
    path:'getSignedUrl',
    body:{
        bucketName:'',
        key: '',
        type: 'Download'
    }
}

export const JobHistoryFilterSchema: DynamicFormArray = {
    FieldsArray: FormFieldArray,
    ButtonsArray: FormButtonArray,
    searchConfig: JobHistorySearchConfig,
    // autoSearchOnLoad:true
}

export const optionExplanations: Array<any> = [
    "Spin ID can be either 9 or 12 digits.",
    "First Name and Last Name are not case sensitive as substrings. An example, searching on 'Paul' will match 'paul', 'paulo' and 'depaul'."
]

export const JobHistroyDataSchema = {
    [FieldNames['SpinId']]: 'SPIN_ID',
    'associateType':'associate_type'
}
export const JobHistoryDisplayTable: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema:[
        { label: "ASSOCIATE TYPE", fieldKey: JobHistroyDataSchema['associateType'],isNotCamelCase:true },
        { label: "SPIN ID", fieldKey: JobHistroyDataSchema['spinId']},
        { label: "FIRST NAME", fieldKey: 'FIRST_NAME' },
        { label: "LAST NAME", fieldKey: 'LAST_NAME' },
        { label: "DEALER CODE", fieldKey: 'DEALER_CODE' },
    ],
    exportConfig: {
        fileName: 'PC_Support',
        schema:{
           'associate_type': "ASSOCIATE TYPE",
           'SPIN_ID': "SPIN ID",
           'FIRST_NAME': "FIRST NAME",
           'LAST_NAME': "LAST NAME",
           'DEALER_CODE':"DEALER CODE"
        },
        exportMessage:'PC Support Data'
    },
    serverSidePaginatation:true,
    breadcrums: [{ level: 1, name: "PC Support" }]
}

export const JobHistoryProps:Props = {
    optionExplanation: optionExplanations,
}